import gql from 'graphql-tag';

export const getAcademicDates = gql`
  query getAcademicCalendar {
    academic {
      calendar {
        id
        career
        title
        name
        description
        startDate
        endDate
        target
      }
    }
  }
`;
